import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import Wrapper from './style';
import theme, { colorScheme as scheme } from '../../configs/nivo';
import dataExample from './data.example';

const Index = (props) => {
  const { dataSource = dataExample, chartProps, colorScheme } = props;

  const CenteredMetric = ({ centerX, centerY }) => {
    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        className="font-paragraph_medium black1"
      >
        {chartProps?.metricName || 'Metrics'}
      </text>
    );
  };
  return (
    <Wrapper>
      <div className="component_pie_canvas">
        <ResponsivePie
          data={dataSource}
          theme={theme}
          margin={{ top: 24, right: 12, bottom: 24, left: 12 }}
          innerRadius={0.6}
          activeOuterRadiusOffset={8}
          colors={colorScheme || { scheme: scheme.default }}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={1}
          arcLinkLabelsColor={{ from: 'color' }}
          arcLinkLabel={(d) => {
            return `${d.id}: ${d.data.valueText}`;
          }}
          arcLinkLabelsStraightLength
          enableArcLabels={false}
          arcLabelsSkipAngle={10}
          startAngle={chartProps?.startAngle || 0}
          endAngle={chartProps?.endAngle || 360}
          arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
          legends={[]}
          layers={[
            'arcs',
            'arcLabels',
            'arcLinkLabels',
            'legends',
            CenteredMetric,
          ]}
          isInteractive={chartProps?.isInteractive || true}
          tooltip={({ datum: { id, color, data } }) => {
            return (
              <div
                style={{
                  padding: 4,
                  background: 'white',
                  border: '1px solid #EDF4F7',
                  boxSizing: 'border-box',
                  boxShadow: '0px 2px 4px -4px rgba(23, 30, 41, 0.1)',
                  bordeRadius: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: 12,
                }}
              >
                <div
                  style={{
                    width: 12,
                    height: 12,
                    backgroundColor: color,
                    marginRight: 4,
                  }}
                />
                <div>
                  <div className="black1" style={{ fontWeight: 600 }}>
                    {id}
                  </div>
                  <div className="black1">{data.valueText}</div>
                </div>
              </div>
            );
          }}
        />
      </div>
      {/* {dataSource.map((item) => {
        return (
          <PieLegend
            dotColor={item.color}
            name={item.name}
            value={item.value}
            key={item.value}
          />
        );
      })} */}
    </Wrapper>
  );
};

export default Index;

// const PieLegend = (props) => {
//   const { dotColor, name, value } = props;
//   return (
//     <PieLegendWrapper dotColor={dotColor}>
//       <span className="dot" />
//       <div>
//         <div className="font-paragraph_medium black3">{name}</div>
//         <div className="font-subtitle1_medium black1">{value}</div>
//       </div>
//     </PieLegendWrapper>
//   );
// };
